// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"t2-z","displaySixCardTiles":"u2-z"};